var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4472 9.97572H4.58871L6.7785 7.78593C7.01432 7.55011 7.01432 7.16269 6.7785 6.92687C6.54267 6.69104 6.15525 6.69104 5.91943 6.92687L2.68529 10.161C2.6516 10.1947 2.63476 10.2284 2.60107 10.2621C2.60107 10.2789 2.58422 10.2789 2.58422 10.2958C2.56738 10.3126 2.55053 10.3463 2.55053 10.3631C2.55053 10.38 2.53369 10.3968 2.53369 10.4137C2.53369 10.4305 2.51684 10.4474 2.51684 10.4642C2.51684 10.4979 2.5 10.5484 2.5 10.5821C2.5 10.6158 2.5 10.6663 2.51684 10.7C2.51684 10.7169 2.53369 10.7337 2.53369 10.7506C2.55053 10.7843 2.55053 10.8011 2.55053 10.8179C2.56738 10.8348 2.56738 10.8685 2.58422 10.8853C2.58422 10.9022 2.60107 10.9022 2.60107 10.919C2.61791 10.9527 2.6516 10.9864 2.68529 11.0201L5.91943 14.2542C6.03734 14.3721 6.18894 14.4395 6.35738 14.4395C6.52583 14.4395 6.67743 14.3721 6.79534 14.2542C7.03116 14.0184 7.03116 13.631 6.79534 13.3951L4.60556 11.2054H16.4641C16.801 11.2054 17.0705 10.9359 17.0705 10.599C17.0536 10.2621 16.7841 9.97572 16.4472 9.97572Z",
    fill: "#DE0E48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.21488204bfcecd5a55497bcc06d7292d.svg";
export { ForwardRef as ReactComponent };